import type { LayerRaw } from '@tsyl/karonte/lib/types/layers'

import { LAYER_ATTRIBUTIONS } from '@/constants/layers/attributions'
import type { LayerInfo } from '@/types/LayerInfo'

const info: LayerInfo = {
  description: {
    'en-US': 'Administrative boundaries from the GADM database of Global Administrative Areas, version 4.1.',
    'es-ES': 'Límites administrativos de la base de datos de áreas administrativas mundiales GADM, versión 4.1.',
    'pt-BR': 'Limites administrativos da base de dados de áreas administrativas globais GADM, versão 4.1.',
    'fr-FR': 'Limites administratives issues de la base de données des zones administratives mondiales GADM, version 4.1.'
  },
  credit: LAYER_ATTRIBUTIONS.gadm,
  sourceUrl: 'https://gadm.org/'
}

const countyNorthAfrica: LayerRaw = {
  id: 'Counties',
  type: 'WMS',
  icon: 'mdi-home',
  url: '/wfas-proxy/geoserver/wms',
  extraArcgisParameter: { copyright: info.credit },
  title: {
    'en-US': 'Administrative Boundaries',
    'pt-BR': 'Limites administrativos',
    'es-ES': 'Límites administrativos',
    'fr-FR': 'Limites administratives'
  },
  zindex: 1,
  active: true,
  activeTarget: 'visibility',
  enabled: false,
  customProperties: { group: 'reference', info },
  legend: {
    title: 'n/a'
  },
  sublayers: [
    {
      id: 'naf:gadm_410africa',
      visible: true,
      legend: {
        title: {
          'en-US': 'Administrative Boundaries',
          'pt-BR': 'Limites administrativos',
          'es-ES': 'Límites administrativos',
          'fr-FR': 'Limites administratives'
        },
        items: [
          {
            icon: 'mdi-slash-forward',
            color: '#000000',
            text: {
              'en-US': 'Administrative Boundary',
              'pt-BR': 'Limite administrativo',
              'es-ES': 'Límite administrativo',
              'fr-FR': 'Limite administrative'
            }
          }
        ]
      }
    }
  ]
}

export default countyNorthAfrica
